import { ObjectID } from 'bson';
import mongoose, { Schema } from 'mongoose';

export interface IProvisionCodeCache {
  _id: ObjectID;
  availabilityCode: string;
  provisionCode: string;
  serviceGroup: ObjectID;
  expireAt: Date;
  updatedAt: Date;
  createdAt: Date;
}

export interface IProvisionCodeCacheDocument extends mongoose.Document, IProvisionCodeCache {
  _id: ObjectID;
}

const provisionCodeCache = new Schema(
  {
    availabilityCode: {
      type: String,
      required: true,
    },
    provisionCode: {
      type: String,
      required: true,
      unique: true,
    },
    serviceGroup: {
      type: Schema.Types.ObjectId,
      ref: 'ServiceGroup',
      required: true,
    },
    // TODO: store the price as well
    expireAt: {
      type: Date,
      required: true,
    },
  },
  { timestamps: true },
);

provisionCodeCache.index({ expireAt: 1 }, { expireAfterSeconds: 0 });

export default provisionCodeCache;
